<script setup>
import { computed } from 'vue';
import { __, formatBytes, convertSecondsToMinutes, formatBytesToGigabytes } from '@/utils'

const { data } = defineProps({
    data: Object
})

const sortKeys = ['call', 'sms', 'data', 'intl_call'];

const handleData = (type, value) => {
    if(type === 'call' || type === 'intl_call') {
        return convertSecondsToMinutes(value);
    } else if(type === 'data') {
        const formatedValue = formatBytesToGigabytes(value);
        return formatedValue.endValue;
    } else {
        return value;
    }
}

const translations = {
    call: {
        title: __('you spoke'),
        desc: __('minutes from')
    },
    sms: {
        title: __('you sent'),
        desc: __('Messages from')
    },
    data: {
        title: __('browsing'),
        desc: __('Data usage out of')
    },
    intl_call: {
        title: __('international calls'),
        desc: __('Call minutes abroad out of')
    }
}

const updatedData = computed(() => {
    return data.map(item => {
        return {
            ...item,
            title: translations[item.usage_type]?.title,
            desc: (item?.group_balance.total  === 'UNLIMITED' || item?.group_balance.total  === '0UNLIMITED') ? __('Surfing from unlimited surfing') : translations[item.usage_type]?.desc,
            from: (item?.group_balance.total  === 'UNLIMITED' || item?.group_balance.total  === '0UNLIMITED') ? "" : handleData(item.usage_type, item?.group_balance.total) || 0,
            spent: handleData(item.usage_type, item?.group_balance.usagev) || 0
        }
    }).sort((a, b) => {
        const aIndex = sortKeys.indexOf(a.usage_type.toLowerCase());
        const bIndex = sortKeys.indexOf(b.usage_type.toLowerCase());
        return aIndex - bIndex;
    });
});
</script>

<template>
    <div class="usage-info">
        <h4 class="usage-info__header" >{{ __('Package utilization in Israel') }}</h4>
        <div class="usage-info__items">
            <template v-for="(item, index) of updatedData" :key="index">
                <div class="usage-item">
                    <h5>{{ item?.title }}</h5>
                    <span class="gradient">{{ item.spent }}</span>
                    <p>{{ item?.desc }} {{ item?.from || '' }}</p>
                </div>
                <div v-if="updatedData.length - 1 > index" class="divider"></div>
            </template>
                
        </div>
    </div>
</template>